import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import { useTranslation } from '../../i18n/resources';
import { ContactInfo } from '../ContactInfo/ContactInfo';
import { MediShareLogoIcon } from '../MediShareLogo/MediShareLogoIcon';
import styles from './ProblemMessage.module.css';

export type ProblemMessageProps = {
  className?: string;
  logMessage: string;
  message?: string;
  subMessage?: string;
};

export const ProblemMessage: FunctionComponent<ProblemMessageProps> = ({
  className,
  logMessage,
  message,
  subMessage,
}) => {
  const { renderTrans } = useTranslation();
  console.error(logMessage);

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.content}>
        <MediShareLogoIcon
          className={styles.logo}
          fill="var(--color-background-contrast)"
        />
        <div className={styles.header}>
          {renderTrans('error', 'timeout_title')}
        </div>
        <div className={styles.text}>
          {message ?? renderTrans('error', 'timeout_message')}
        </div>
        <div className={styles.text}>
          {subMessage ?? renderTrans('error', 'timeout_contact_us')}
        </div>
        <ContactInfo />
      </div>
    </div>
  );
};
